import React, { Component, PropTypes } from "react";
import { Input, Dropdown, Loader, Dimmer, Checkbox } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  ValidMe,
  forceValidation,
  phoneTypesEnum,
  validatePhoneNumber,
  EMAIL_VALIDATION_REGULAR_EXPRESSION
} from "../../shared/validMeReact";
import {
  getApiCustomerProfileData,
  updateCustomerProfileData,
  setIsLoadingOnCustomerProfile,
  resetCustomerProfileForm,
  updateBookingOnlyCustomerProfileData
} from "../../../actions/customerProfile";
import objectAssign from "object-assign";
import AddressForm from "../../shared/addressForm";
import { formatPhone } from "../../../utils/helpers";
import {
  updateGlobalErrorMessage,
  removeGlobalErrorMessageIfMatchesThisString
} from "../../../actions/globalError";
import { menuNamesEnum, paymentStatusEnum } from "../../../state/initialState";
import { updateCurrentMenu } from "../../../actions/menu";

@connect(mapStateToProps)
export default class CenterPanelCustomerProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerSnapshotTaken: false,
      hoveredHelpViewCustomerDetails: false
    };
  }

  componentDidMount() {
    let {
      businessCountryCode,
      limitedPermissions,
      customerProfileData,
      apiCustomerProfileData,
      loadingCustomerProfile
    } = this.props;
    let { selectedCustomer } = this.props.appointmentStepData;
    if (
      selectedCustomer.id &&
      limitedPermissions.canViewCustomerProfile != false &&
      apiCustomerProfileData == "{}" &&
      !loadingCustomerProfile
    ) {
      this.props.dispatch(getApiCustomerProfileData(selectedCustomer.id));
    }
    sessionStorage.setItem(
      "CUSTOMER_PROFILE_DATA_SNAPSHOT",
      JSON.stringify(customerProfileData)
    );

    window.validMeReact.validMeManager.VALIDATION.CountryCode = businessCountryCode;

    this.props.dispatch(updateGlobalErrorMessage(""));
  }

  componentWillReceiveProps(newProps) {
    if (this.props.loadingCustomerProfile && !newProps.loadingCustomerProfile) {
      sessionStorage.setItem(
        "CUSTOMER_PROFILE_DATA_SNAPSHOT",
        JSON.stringify(newProps.customerProfileData)
      );
    }
  }
  updateCustomerProfileData = data => {
    let newData = objectAssign({}, this.props.customerProfileData, data);
    this.props.dispatch(updateCustomerProfileData(newData));
  };

  dispatchUpdateCurrentMenu = menuSelected => {
    this.props.dispatch(updateCurrentMenu(menuSelected));
  };

  updateCustomerAddressData = data => {
    let newAddressData = objectAssign(
      {},
      this.props.customerProfileData.address,
      data
    );
    this.updateCustomerProfileData({ address: newAddressData });
  };

  firstNameChangeHandler = event => {
    this.updateCustomerProfileData({ firstName: event.target.value });
    setTimeout(() => {
      forceValidation(null, null, "customerProfileNames");
    }, 0); //execute in next loop
  };

  lastNameChangeHandler = event => {
    this.updateCustomerProfileData({ lastName: event.target.value });
    setTimeout(() => {
      forceValidation(null, null, "customerProfileNames");
    }, 0); //execute in next loop
  };

  emailChangeHandler = event => {
    let { apiCustomerProfileData } = this.props;
    let { ErrorEmailCannotBeDeletedInThisPage } = window.APP.LANGUAGE.Errors;

    // WE dont check how many emails are present in the current customer update mode (booking only), since the customer will not be updated , only the appointment
    if (
      event.target.value == "" &&
      apiCustomerProfileData.emails &&
      apiCustomerProfileData.emails.length > 1
    ) {
      this.props.dispatch(
        updateGlobalErrorMessage({
          message: ErrorEmailCannotBeDeletedInThisPage
        })
      );
    } else {
      this.props.dispatch(
        removeGlobalErrorMessageIfMatchesThisString(
          ErrorEmailCannotBeDeletedInThisPage
        )
      );
    }
    this.updateCustomerProfileData({ email: event.target.value });
  };

  phoneChangeHandler = event => {
    let { apiCustomerProfileData } = this.props;
    let { ErrorPhoneCannotBeDeletedInThisPage } = window.APP.LANGUAGE.Errors;

    let noSpacesPhone = event.target.value
      .split(" ")
      .join()
      .replace(/,/g, "")
      .replace(/\(/g, "")
      .replace(/\)/g, "")
      .replace(/-/g, "")
      .replace(/\+/g, "");
    var numericTest = /^\d+$/;

    if (
      numericTest.test(noSpacesPhone) ||
      event.target.value == "" ||
      event.target.value == "+"
    ) {
      if (event.type == "change") {
        if (
          event.target.value == "" &&
          apiCustomerProfileData.phonenumbers &&
          apiCustomerProfileData.phonenumbers.length > 1
        ) {
          this.props.dispatch(
            updateGlobalErrorMessage({
              message: ErrorPhoneCannotBeDeletedInThisPage
            })
          );
        } else {
          this.props.dispatch(
            removeGlobalErrorMessageIfMatchesThisString(
              ErrorPhoneCannotBeDeletedInThisPage
            )
          );
        }

        this.updateCustomerProfileData({ phoneNumber: event.target.value }); // DES- 709 formatting in change causes issues. Hence moved to blur. But without state update it will not reflect in UI.
      } else {
        this.updateCustomerProfileData({
          phoneNumber: formatPhone(event.target.value)
        });
      }
    }

    if (event.type !== "change") {
      setTimeout(() => {
        forceValidation(null, null, "customerProfileContacts");
      }, 0); //execute in next loop
    }
  };

  address1ChangeHandler = addressValue => {
    this.updateCustomerAddressData({ address1: addressValue });
  };

  cityChangeHandler = cityValue => {
    this.updateCustomerAddressData({ city: cityValue });
  };

  stateChangeHandler = selectedState => {
    this.updateCustomerAddressData({ state: selectedState });
  };

  postalCodeChangeHandler = zipCodeValue => {
    this.updateCustomerAddressData({ postalcode: zipCodeValue });
  };

  blockedChangeHandler = event => {
    let { blocked } = this.props.customerProfileData;
    this.updateCustomerProfileData({ blocked: !blocked });
  };

  captureCCChangeHandler = event => {
    let { captureCreditCard } = this.props.customerProfileData;
    this.updateCustomerProfileData({ captureCreditCard: !captureCreditCard });
  };

  openCustomerDetailspage = () => {
    let { organizationId, selectedCustomer } = this.props.appointmentStepData;
    if (selectedCustomer && selectedCustomer.id) {
      window.open(
        `${window.APP.apiDomain}/manager/customer/index/${organizationId}#cust_${selectedCustomer.id}`,
        "_blank"
      );
    }
  };

  dispatchResetCustomerProfileForm = () => {
    this.props.dispatch(resetCustomerProfileForm());
  };

  updateBookingOnlyCustomerProfileData = data => {
    let newData = objectAssign(
      {},
      this.props.bookingOnlyCustomerProfileData,
      data
    );
    this.props.dispatch(updateBookingOnlyCustomerProfileData(newData));
  };

  handleHelpViewCustomerDetailsMouseIn = () => {
    this.setState({ hoveredHelpViewCustomerDetails: true });
  };
  handleHelpViewCustomerDetailsMouseOut = () => {
    this.setState({ hoveredHelpViewCustomerDetails: false });
  };

  render() {
    let {
      customerProfileData: {
        firstName,
        lastName,
        email,
        phoneNumber,
        address,
        blocked,
        captureCreditCard
      },
      limitedPermissions,
      currentBookingId
    } = this.props;
    let {
      selectedCustomer,
      paymentStatus,
      selectedAppointmentStatus
    } = this.props.appointmentStepData;
    let { CustomerProfile } = window.APP.LANGUAGE.Pages;

    let phoneTypesSupported = `${phoneTypesEnum.MOBILE}-${phoneTypesEnum.FIXED_LINE}-${phoneTypesEnum.FIXED_LINE_OR_MOBILE}-${phoneTypesEnum.PERSONAL_NUMBER}-${phoneTypesEnum.VOIP}-${phoneTypesEnum.TOLL_FREE}`;
    let {
      UpdateAllCustomerRecords,
      DetailsTitle,
      RequiredFields,
      ContactTitle,
      OneFieldRequired,
      FirstNamePlaceholder,
      LastNamePlaceholder,
      EmailPlaceholder,
      PhonePlaceholder,
      AddressTitle,
      BlockCustomerText,
      AlwaysRequireCCText,
      ViewDetailsText,
      CannotEditCustomerProfileMessage,
      UpdateAllCustomersHelpMessage,
      ViewCustomerDetailsHelpMessage
    } = CustomerProfile;

    let cannotEditBooking =
      !limitedPermissions.canEditAllBookings &&
      limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) < 0 &&
      currentBookingId;
    let that = this;
    return (
      <div className="tabpane customer-profile-tab">
        <Dimmer active={this.props.loadingCustomerProfile}>
          <Loader />
        </Dimmer>
        <div className="ui two column grid">
          <section className="customer-info column">
            <ValidMe
              condition={() => {
                return (
                  this.props.customerProfileData.firstName.length > 0 ||
                  this.props.customerProfileData.lastName.length > 0
                );
              }}
              validmemessagecondition={
                window.APP.LANGUAGE.Pages.CustomerProfile.Errors.NameRequired
              }
              validmefor="condition"
              group="customerProfileNames"
            >
              <h5 className="label-title">
                {DetailsTitle} <span>{RequiredFields}</span>
              </h5>
              <Input
                disabled={this.props.customerProfileData.deleted}
                value={firstName}
                onChange={this.firstNameChangeHandler}
                autoComplete="off"
                name="booking_firstName"
                tabIndex="1"
                placeholder={FirstNamePlaceholder}
                className="booking_firstname booking_auto_complete"
              />
            </ValidMe>
            <ValidMe
              condition={() => {
                return (
                  this.props.customerProfileData.firstName.length > 0 ||
                  this.props.customerProfileData.lastName.length > 0
                );
              }}
              validmemessagecondition={
                window.APP.LANGUAGE.Pages.CustomerProfile.Errors.NameRequired
              }
              validmefor="condition&numeric"
              group="customerProfileNames"
            >
              <Input
                disabled={this.props.customerProfileData.deleted}
                value={lastName}
                onChange={this.lastNameChangeHandler}
                autoComplete="off"
                name="booking_lastName"
                tabIndex="2"
                placeholder={LastNamePlaceholder}
                className="booking_lastname  booking_auto_complete"
              />
            </ValidMe>
          </section>
          <section className="customer-info2 column">
            <ValidMe
              hideerrorsofgroupifallgood={true}
              condition={value => {
                let email = value;
                let conditionFulfilled =
                  email.length > 0 ||
                  that.props.customerProfileData.phoneNumber.length > 0;
                if (
                  value != "" &&
                  !EMAIL_VALIDATION_REGULAR_EXPRESSION.test(value)
                ) {
                  conditionFulfilled = false;
                }

                return conditionFulfilled;
              }}
              validmemessagecondition={
                window.APP.LANGUAGE.Pages.CustomerProfile.Errors.ContactRequired
              }
              validmemessage={window.APP.LANGUAGE.Errors.EmailInvalid}
              secondaryconditionpassed={
                this.props.customerProfileData.phoneNumber.length > 0
              }
              optional
              validmefor="condition&email"
              group="customerProfileContacts"
            >
              <h5 className="label-title">
                {ContactTitle} <span>{OneFieldRequired}</span>
              </h5>
              <Input
                className="customer-email"
                disabled={this.props.customerProfileData.deleted}
                type="email"
                value={email}
                onBlur={() => {
                  setTimeout(() => {
                    forceValidation(null, null, "customerProfileContacts");
                  }, 0); //execute in next loop
                }}
                onChange={this.emailChangeHandler}
                autoComplete="off"
                name="booking_email"
                tabIndex="3"
                placeholder={EmailPlaceholder}
                className="booking_email_cp booking_auto_complete"
              />
            </ValidMe>
            <ValidMe
              hideerrorsofgroupifallgood={true}
              condition={(value, validRules, props) => {
                let phone = value;
                let conditionFulfilled =
                  that.props.customerProfileData.email.length > 0 ||
                  phone.length > 0;
                phone = phone.replace("+", "");
                if (
                  value != "" &&
                  !validatePhoneNumber(phone, validRules, props).good
                ) {
                  conditionFulfilled = false;
                }
                return conditionFulfilled;
              }}
              validmemessagecondition={
                window.APP.LANGUAGE.Pages.CustomerProfile.Errors.ContactRequired
              }
              validmemessage={window.APP.LANGUAGE.Errors.PhoneNumberIsInvalid}
              secondaryconditionpassed={
                this.props.customerProfileData.email.length > 0
              }
              optional
              validmefor={`condition&phoneNumber@${phoneTypesSupported}`}
              group="customerProfileContacts"
            >
              <Input
                className="customer-phone"
                disabled={this.props.customerProfileData.deleted}
                onBlur={this.phoneChangeHandler}
                type="tel"
                value={phoneNumber}
                onChange={this.phoneChangeHandler}
                autoComplete="off"
                name="booking_phonenumber"
                tabIndex="4"
                placeholder={PhonePlaceholder}
                className="phone-input booking_auto_complete"
              />
            </ValidMe>
          </section>
        </div>
        {this.props.customerProfileData.deleted ? (
          <div className="customer-deleted">Customer record deleted</div>
        ) : (
          ""
        )}

        <hr />
        <div className="ui grid">
          <section className="address eight wide column">
            <label className="label-title">{AddressTitle}</label>
            <AddressForm
              disabled={this.props.customerProfileData.deleted}
              postalCodeChangeHandler={this.postalCodeChangeHandler}
              addressValue={address}
              addressChangeHandler={this.address1ChangeHandler}
              cityChangeHandler={this.cityChangeHandler}
              stateChangeHandler={this.stateChangeHandler}
              postalCodeChangeHandler={this.postalCodeChangeHandler}
            />
          </section>

          <section className="customer_controls eight wide column disabled-row">
            <div className="block-customer-label">
              <label
                className={
                  this.props.customerProfileData.deleted ? "disabled" : ""
                }
              >
                {BlockCustomerText}
              </label>
              <Checkbox
                disabled={
                  this.props.customerProfileData.email == "" ||
                  this.props.customerProfileData.deleted
                }
                toggle
                onChange={this.blockedChangeHandler}
                checked={blocked}
              />
            </div>
            <div className="card-required-label">
              <label
                className={
                  this.props.customerProfileData.deleted ? "disabled" : ""
                }
              >
                {AlwaysRequireCCText}
              </label>{" "}
              <Checkbox
                disabled={this.props.customerProfileData.deleted}
                toggle
                onChange={this.captureCCChangeHandler}
                checked={captureCreditCard}
              />
            </div>

            {selectedCustomer &&
            selectedCustomer.id &&
            !this.props.customerProfileData.deleted ? (
              <div>
                <a
                  className="customer-details"
                  onClick={this.openCustomerDetailspage}
                >
                  {ViewDetailsText}
                </a>
                <span
                  onMouseOver={this.handleHelpViewCustomerDetailsMouseIn}
                  onMouseOut={this.handleHelpViewCustomerDetailsMouseOut}
                  className="view-customer-details-tooltip"
                >
                  {this.state.hoveredHelpViewCustomerDetails ? (
                    <div
                      className="tooltip-text"
                      dangerouslySetInnerHTML={{
                        __html: ViewCustomerDetailsHelpMessage
                      }}
                    ></div>
                  ) : (
                    ""
                  )}
                </span>
              </div>
            ) : (
              ""
            )}
          </section>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    bookingOnlyCustomerProfileData:
      state.customerProfileReducer.bookingOnlyCustomerProfileData,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    gotCustomerProfileData: state.customerProfileReducer.gotCustomerProfileData,
    apiCustomerProfileData: state.customerProfileReducer.apiCustomerProfileData,
    businessCountryCode: state.appointmentStepReducer.businessCountryCode,
    currentBookingId: state.bookingReducer.currentBookingId,
    loadingCustomerProfile: state.customerProfileReducer.loadingCustomerProfile
  };
}
